var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUnverifiedClaimIc(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6661_67465)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.8574 7.68945L36.2517 11.8427V35.6689H19.8574V7.68945Z",
    fill: "#256AF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3379 16.8706H31.7699",
    stroke: "white",
    strokeWidth: 2.30769
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3379 22.9907H31.7699",
    stroke: "white",
    strokeWidth: 2.30769
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3379 29.1118H31.7699",
    stroke: "white",
    strokeWidth: 2.30769
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.36523 8.75322L27.071 0.913574V35.6693H9.36523V8.75322Z",
    fill: "#256AF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.502 13.8105H21.934",
    stroke: "white",
    strokeWidth: 2.30769
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.502 19.9307H21.934",
    stroke: "white",
    strokeWidth: 2.30769
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.502 26.0513H21.934",
    stroke: "white",
    strokeWidth: 2.30769
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.11157 20.9449C9.00064 19.4109 11.2157 19.4109 12.1048 20.9449L19.927 34.4418C20.8186 35.9803 19.7086 37.9067 17.9304 37.9067H2.28593C0.507774 37.9067 -0.602297 35.9803 0.28933 34.4418L8.11157 20.9449Z",
    fill: "#6CCC93"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1074 24.6533L10.1074 30.1405",
    stroke: "white",
    strokeWidth: 2.30769,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.1089,
    cy: 34.2027,
    r: 1.46635,
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6661_67465"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnverifiedClaimIc);
export default __webpack_public_path__ + "static/media/unverified-claim-ic.0ebacfcc69d1ad052153a4ffa8c24a91.svg";
export { ForwardRef as ReactComponent };